export default __webpack_public_path__ + "static/Sketch1-6cd58e847bb5e38bb623cb1410cb9110.jpg";